@let view = data();

<div>
  <ui-headlines [data]="view.headlines" [level]="1"></ui-headlines>

  <div [innerHtml]="view.content" class="rte" uiHtmlDataLink></div>
</div>
